import React, { Component } from 'react';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';
import authorize from '../authorization/authorize';
import PortalToastrContainer from '../portal/portalToastrContainer';
import PrivateRouteWrapper from '../router/privateRouteWrapper';
import RolesGridContainer from '../roles/rolesGrid';

const AuthorizedRolesGridContainer = authorize([Permissions.manageRoles], AccessDeniedBehavior.displayError)(RolesGridContainer);

export default class RolesContainer extends Component {

    render() {

        return(
            <PrivateRouteWrapper>
                <PortalToastrContainer />
                <AuthorizedRolesGridContainer />
            </PrivateRouteWrapper>
        );
    }
}